try {
  require("@rails/ujs").start()
  }catch(e){
  }
  require("../detect-ie")
  require("../utilities")
  require("../form-utilities")
  require("../videojs")
  require("../presentable")
  require("../present-tooltip.js")
  require("../toast.js")
  require("../topshops/faq-nav")
  require("../topshops/mobile-nav")
  require("../topshops/open-position-modal")
  require("../topshops/get-in-touch-form")
  require("../topshops/photo-viewer")
  require("../topshops/carousel")
